export default "__VITE_PUBLIC_ASSET__948590a6__"